import { Box } from '@factorialco/deprecated-design-system'
import { JobCatalogEnumsJobCatalogTreeNodeTypesEnum } from 'generated/resources/graphql'

import { TreeNode, Workplace } from 'modules/cost_centers/components/CostCentersStructure/types'

import { PreviewCostCenters } from './Table'

const CostCentersStructurePreview = ({
  treeArray,
  jobStructure,
  expandWorkplace,
  workplaces,
}: {
  treeArray: TreeNode[]
  jobStructure?: JobCatalogEnumsJobCatalogTreeNodeTypesEnum
  expandWorkplace: boolean
  workplaces: Workplace[]
}) => {
  // Key forces PreviewCostCenters (and its useDataCollectionSource) to fully
  // remount when the configuration changes, avoiding stale fetchData closures.
  const previewKey = `${jobStructure ?? 'none'}-${expandWorkplace}`

  return (
    <Box flexGrow paddingTop="s16">
      <Box flexGrow paddingX="s24">
        <PreviewCostCenters
          key={previewKey}
          treeArray={treeArray}
          jobStructure={jobStructure}
          expandWorkplace={expandWorkplace}
          workplaces={workplaces}
        />
      </Box>
    </Box>
  )
}

export { CostCentersStructurePreview }
